import { useEffect } from 'react';
import { useToasterStore, toast } from 'react-hot-toast';

const MAX_TOASTS = 2;

export default function ToastLimiter() {
  const { toasts } = useToasterStore();

  useEffect(() => {
    const visibleToasts = toasts.filter((t) => t.visible);
    if (visibleToasts.length > MAX_TOASTS) {
      // Dismiss the oldest toast
      toast.dismiss(visibleToasts[0].id);
    }
  }, [toasts]);

  return null; // This component does not render anything
}
